import { Stack, TextField, Typography, Button } from '@mui/material';
import { createUserWithEmailAndPassword, getAuth } from 'firebase/auth';
import Alert from '@mui/material/Alert';
import { useState } from 'react';

import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { setError } from '../services/Errors';

const Signup = () => {
    const [loginObj, setLoginObj] = useState(null);
    const [alert, setAlert] = useState({ open: false });

    const auth = getAuth();
    const history = useHistory();

    const tryLogin = () => {
        createUserWithEmailAndPassword(auth, loginObj.email, loginObj.password)
            .then((userCredential) => {
                history.push('./');
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                setError(loginObj.email, `${errorCode}: ${errorMessage}`);

                setAlert({ open: true, type: 'error', message: 'Kunne ikke opprette bruker. Kan denne ha blitt opprettet fra før?' });
            });
    };

    return (
        <>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }} gutterBottom>
                Opprett epost bruker
            </Typography>
            <Typography variant="body1" sx={{ maxWidth: '500px' }} gutterBottom>
                Ved å opprette bruker og ta i bruk denne applikasjonen <Link to="/terms">godtar du våre vilkår for bruk.</Link>
            </Typography>
            <Stack spacing={2} mt={3}>
                <TextField
                    variant="outlined"
                    label="Epost"
                    type="string"
                    autoComplete="current-email"
                    onChange={({ target }) => setLoginObj({ ...loginObj, email: target.value })}
                />
                <TextField
                    variant="outlined"
                    label="Passord"
                    type="password"
                    autoComplete="current-password"
                    onChange={({ target }) => setLoginObj({ ...loginObj, password: target.value })}
                />
                <Stack direction="row" spacing={2}>
                    <Button onClick={tryLogin} sx={{ maxWidth: '180px' }} variant="contained" color="primary">
                        Opprett bruker
                    </Button>
                </Stack>
                {alert.open && <Alert severity={alert.type}>{alert.message}</Alert>}
            </Stack>
        </>
    );
};

export default Signup;